<script lang="ts">
  import type { BackendActor } from './lib/actor';
  import { auth, login, logout } from './lib/auth';
  import InGame from './lib/components/InGame.svelte';
  import InLobby from './lib/components/InLobby.svelte';
  import Outside from './lib/components/Outside.svelte';
  import OutsideLayout from './lib/components/OutsideLayout.svelte';
  import { gameState } from './lib/gameState';
</script>

<main class="font-body font-light">
  {#if $auth.state === 'anonymous' || $auth.state === 'error'}
    <OutsideLayout>
      <button on:click={() => login()} class="btn btn-primary"
        >Log in to play</button
      >
    </OutsideLayout>
  {:else if $auth.state === 'authenticated'}
    {#if $gameState.state === 'outside'}
      <Outside actor={$auth.actor} auth={$auth} />
    {:else if $gameState.state === 'lobby'}
      <InLobby actor={$auth.actor} state={$gameState} />
    {:else if $gameState.state === 'in-game'}
      <InGame actor={$auth.actor} />
    {/if}
  {/if}
</main>
